import React, { useEffect, useState } from 'react';
import { ActionsPendingDetail } from './ActionsPendingDetail';
import { NameAndDaysDetail } from './NameAndDaysDetail';
import { MoveCandidateProps } from '../../components/MoveCandidateStageModal';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { JobState } from '../../../../entities/JobDetails';
import { HiringMember } from '../../../../entities/HiringMember';
import { User } from '../../../../entities/User';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { PipelineApplication } from '../../../../entities/applicant_tracking/PipelineApplication';
import { AlertObject } from '../../../../components/Alert';
import { getApplicationActionInfo } from '../../../../utils/applicant_tracking/actions/applicationActions';
import { JobHiringMemberRole } from '../../../../entities/JobHiringMemberRole';
import { PipelineApplicationService } from '../../../../services/applicant_tracking/PipelineApplicationsService';

interface PropTypes {
  application: PipelineApplication;
  atsSignableOfferEnabled: boolean;
  currentHiringMember?: HiringMember;
  currentStage: string;
  currentUser: User;
  daysOnStage: number;
  emailAuthorizeUrl: string;
  jobStatus: JobState;
  name: string;
  offerEnabled?: boolean;
  offerRequisitionFlowEnabled: boolean;
  onRejectApplication: (application: PipelineApplication) => void;
  profileLink: string;
  onMoveCandidate?: (
    application: PipelineApplication,
    action?: MoveCandidateProps,
  ) => void;
  setAlert: (alert: AlertObject) => void;
}

export function CandidateCard(props: PropTypes) {
  const [application, setApplication] = useState<PipelineApplication>(
    props.application,
  );
  const [isDragEnabled, setDragEnabled] = useState<boolean>(
    getApplicationActionInfo(
      application,
      props.currentUser.isAdmin,
      props.currentHiringMember?.role as JobHiringMemberRole,
      'Move candidate',
    ).allowed,
  );

  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: props.application.id,
      data: props,
      disabled: !isDragEnabled,
    });
  const style = {
    transform: CSS.Translate.toString(transform),
  };

  const reloadApplication = () =>
    PipelineApplicationService.show(props.application.id).then(setApplication);

  useEffect(() => setApplication(props.application), [props.application]);

  if (isDragging) {
    return;
  }

  return (
    <div
      className={classNames(
        'border border-white bg-gray px-3',
        styles['candidate-card'],
        isDragEnabled && styles['cursor-move'],
      )}
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
    >
      <NameAndDaysDetail
        application={application}
        atsSignableOfferEnabled={props.atsSignableOfferEnabled}
        currentHiringMember={props.currentHiringMember}
        currentStage={props.currentStage}
        currentUser={props.currentUser}
        daysOnStage={props.daysOnStage}
        emailAuthorizeUrl={props.emailAuthorizeUrl}
        jobStatus={props.jobStatus}
        name={props.name}
        profileLink={props.profileLink}
        offerEnabled={props.offerEnabled}
        offerRequisitionFlowEnabled={props.offerRequisitionFlowEnabled}
        onMoveCandidate={props.onMoveCandidate}
        onRejectApplication={props.onRejectApplication}
        reloadApplication={reloadApplication}
        setAlert={props.setAlert}
        setDragEnabled={setDragEnabled}
      />
      <ActionsPendingDetail
        actionsPending={application.totalPendingActions}
        daysOnStage={props.daysOnStage}
      />
    </div>
  );
}
